import * as yup from "yup";

export const EstudianteActivoValidate = yup.object().shape({
    codestudiante: yup.string().trim().required("Ingrese una matricula")
    .matches(/^\d{9}$/, "La matrícula debe tener exactamente 9 dígitos"),
  });

  export const SolicitudAyudanteValidate = yup.object().shape({
    descripcion: yup.string().trim().required('La descripción de la necesidad es requerida')
    .test('requiredIfLegth', 'Se excedio el máximo de caracteres 250', function (value) {
        return value !== undefined ? value.length <= 250 : true;
    }),
    //termino: yup.string().trim().required('El término es requerido'),
    horas: yup.string().trim().required('Las horas son requeridas'),
    actividades: yup.string().trim().required('Las actividades son requeridas')
    .test('requiredIfLegth', 'Se excedio el máximo de caracteres 500', function (value) {
        return value !== undefined ? value.length <= 500 : true;
    }),
    docente: yup.string().trim().required('El docente es requerido'),
    tipofinanciamiento: yup.string().required('Debes seleccionar un tipo de financiamiento.'),
});

export const AccionSolicitudAyudantiaValidate = yup.object().shape({
    horas: yup.string().trim().required("Escoja las horas correspondientes"),
    comentario : yup.string().trim().required("Por favor ingrese un comentario")

});

export const RechzarMultipleValidate = yup.object().shape({
    comentario : yup.string().trim().required("Por favor ingrese un comentario")
});

export const AccionHorasValidate = yup.object().shape({
    horas: yup.string().trim().required("Escoja las horas correspondientes")
});